import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Toaster, toast } from "react-hot-toast";
import axios from "axios";

// Async Thunks for API Calls

const API_URL = "https://api.jksolutn.com/api/loan";
// const API_URL = "http://localhost:5000/api/loan";

export const submitLoanApplication = createAsyncThunk(
  "loans/submitApplication",
  async (loanData) => {
    try {
      const response = await axios.post(`${API_URL}/apply`, loanData);
      console.log(response.data);
      toast.success(response.data.message);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchCustomersSummary = createAsyncThunk(
  "customer/fetchCustomersSummary",
  async (page = 1, thunkAPI) => {
    try {
      const response = await fetch(
        `${API_URL}/customers-loan-summary-all?page=${page}`,
      );
      console.log(response.data);

      return await response.json();
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchCustomerDetails = createAsyncThunk(
  "customer/fetchDetails",
  async (bvn) => {
    try {
      const response = await fetch(`${API_URL}/get-customers/details/${bvn}`);
      console.log(response);

      return await response.json();
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchLoans = createAsyncThunk(
  "loans/fetchLoans",
  async ({ page = 1, limit = 12 }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${API_URL}/loans?page=${page}&limit=${limit}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
export const fetchAdminLoans = createAsyncThunk(
  "loans/fetchAdminLoans",
  async () => {
    try {
      const response = await fetch(`${API_URL}/all-loans-for-admin`); // Adjust API endpoint as needed
      return response.json();
    } catch (error) {
      console.error(error);
    }
  },
);

export const fetchAdminLoansNewOne = createAsyncThunk(
  "adminLoans/fetchAdminLoansNewOne",
  async ({ page = 1, limit = 20 }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_URL}/all-loans-for-admin-newone?page=${page}&limit=${limit}`,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to fetch loans" },
      );
    }
  },
);

export const fetchAdminLoansSearch = createAsyncThunk(
  "loan/fetchAdminLoansSearch",
  async (search = "", { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_URL}/all-loans-for-admin-search?search=${search}`,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  },
);

export const fetchWaitingLoans = createAsyncThunk(
  "loans/fetchWaitingLoans",
  async ({ page = 1, limit = 10 }) => {
    try {
      const response = await fetch(
        `${API_URL}/loaner/pending-approval?page=${page}&limit=${limit}`,
      );
      const data = await response.json();
      console.log("Fetched Data:", data);
      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchWaitingDisbursementLoans = createAsyncThunk(
  "loan/fetchWaitingDisbursementLoans",
  async () => {
    try {
      const response = await axios.get(
        `${API_URL}/loaner/waiting-disbursement`,
      );
      console.log(response.data);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchActiveCustomers = createAsyncThunk(
  "loan/fetchActiveCustomers",
  async () => {
    try {
      const response = await axios.get(`${API_URL}/loans/active-customers`);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchRepaymentSchedule = createAsyncThunk(
  "loan/fetchRepaymentSchedule",
  async (id) => {
    try {
      const response = await axios.get(
        `${API_URL}/loans/${id}/repayment-schedule`,
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchLoanById = createAsyncThunk(
  "loans/fetchLoanById",
  async (id) => {
    try {
      const response = await axios.get(`${API_URL}/loans/${id}`);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);
export const fetchLoanByBvn = createAsyncThunk(
  "loans/fetchLoanByBvn",
  async (bvn) => {
    try {
      const response = await axios.get(`${API_URL}/customers/loans/${bvn}`);
      console.log(response.data);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchPendingLoans = createAsyncThunk(
  "loan/fetchPendingLoans",
  async () => {
    const response = await axios.get(`${API_URL}/customers/pending-loans`);
    return response.data;
  },
);

export const fetchRejectedCustomers = createAsyncThunk(
  "loans/fetchRejectedCustomers",
  async () => {
    const response = await axios.get(`${API_URL}/customers-loan/rejected`);
    return response.data;
  },
);

export const makePaymenting = createAsyncThunk(
  "loans/makePaymenting",
  async ({ id, amount }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/loans/${id}/payment`, {
        amount,
      });
      console.log(response);
      console.log(response.data);

      return response.data;
    } catch (err) {
      const fallback = err?.response?.data || {
        error: err?.message || "Failed to make payment",
      };
      return rejectWithValue(fallback);
    }
  },
);

export const disburseLoan = createAsyncThunk(
  "loan/disburseLoan",
  async (id) => {
    try {
      const response = await axios.post(`${API_URL}/loaner/disburse/${id}`);
      console.log(response, response.data);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

// Approve loan
export const approveLoan = createAsyncThunk(
  "loans/approveLoan",
  async ({ id, amountApproved }) => {
    try {
      const response = await fetch(`${API_URL}/loaner/${id}/approve`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amountApproved }),
      });
      console.log(response.json());

      return response.json();
    } catch (err) {
      console.log(err);
    }
  },
);

// Reject loan
export const rejectLoan = createAsyncThunk(
  "loans/rejectLoan",
  async ({ id, rejectionReason }) => {
    try {
      const response = await fetch(`${API_URL}/loans/${id}/reject`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rejectionReason }),
      });
      console.log(response.json());

      return response.json();
    } catch (err) {
      console.log(err);
    }
  },
);

// Async thunk for updating loan
export const updateLoan = createAsyncThunk(
  "loans/updateLoan",
  async ({ id, updateData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${API_URL}/editting-for-a-user/loans/${id}`,
        updateData,
      );
      return response.data; // contains { message, loan }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const transferLoanGroup = createAsyncThunk(
  "loans/transferLoanGroup",
  async ({ id, groupDetails }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${API_URL}/transfer-loan-group/loans-new/${id}`,
        { groupDetails },
      );
      return response.data; // contains { message, loan }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Async thunk for editing a loan (sets status = "edited")
export const editLoanStatus = createAsyncThunk(
  "loans/editLoanStatus",
  async (loanId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/editing-loan/loans/${loanId}`,
      );
      return response.data; // returns updated loan
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Error editing loan" },
      );
    }
  },
);

// Fetch active loans from backend
// export const fetchCustomerActiveLoans = createAsyncThunk(
//   "loans/fetchCustomersActiveLoans",
//   async () => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/allcustomers/loans/active-loans`
//       );
//       return response.data;
//     } catch (err) {
//       console.log(err);
//     }
//   }
// );

export const fetchCustomerActiveLoans = createAsyncThunk(
  "loans/fetchCustomerActiveLoans",
  async ({ page = 1, limit = 20 }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_URL}/allcustomers/loans/active-loans?page=${page}&limit=${limit}`,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || err.message);
    }
  },
);

export const fetchCustomerActiveLoansSearch = createAsyncThunk(
  "loans/fetchCustomerActiveLoansSearch",
  async ({ csoName, search }, { rejectWithValue }) => {
    try {
      console.log(search);

      const res = await axios.get(
        `${API_URL}/allcustomers-search/loans/active-loans-search`,
        {
          params: { csoName, search },
        },
      );
      return res.data;
      console.log(res.data);
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch active loans",
      );
    }
  },
);

export const allLaonfTransactions = createAsyncThunk(
  "loans/fetchallLoanTransactions",
  async () => {
    try {
      const response = await axios.get(`${API_URL}/fetchallLoanTransactions`);
      console.log(response.data);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchLoansByMonth = createAsyncThunk(
  "loans/fetchLoansByMonth",
  async ({ year, month }) => {
    try {
      const response = await axios.get(
        `${API_URL}/allLoanTransactions/${year}/${month}`,
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const fetchDisbursementDataChart = createAsyncThunk(
  "disbursement/fetchDisbursementDataChart",
  async () => {
    const response = await fetch(`${API_URL}/loans-chart/loans`);
    const data = await response.json();
    console.log(data);

    return data;
  },
);

export const fetchLoanMonthlySummary = createAsyncThunk(
  "loans/fetchLoanMonthlySummary",
  async (year, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}/loans-chart/monthly-summary`,
        {
          params: { year },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.message ||
        "Failed to load monthly summary";
      return rejectWithValue(message);
    }
  },
);

export const fetchLoanMonthlyMatrics = createAsyncThunk(
  "loans/fetchLoanMonthlyMatrics",
  async (year, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}/loans-chart/monthly-metrics`,
        {
          params: { year },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.message ||
        "Failed to load monthly summary";
      return rejectWithValue(message);
    }
  },
);

export const fetchAllLoansByCsoId = createAsyncThunk(
  "loans/fetchAllLoansByCsoId",
  async ({ csoId }) => {
    const response = await axios.get(
      `${API_URL}/getLoansByCsoId?csoId=${csoId}`,
    );
    return response.data;
  },
);

export const fetchAllLoansByCsoIdLoanDashboardLoans = createAsyncThunk(
  "loans/fetchAllLoansByCsoIdLoanDashboardLoans",
  async (csoId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${API_URL}/fetchLoansByCso-loan-dashbord-loans/${csoId}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Error fetching loans",
      );
    }
  },
);

export const fetchCsoActiveLoans = createAsyncThunk(
  "loan/fetchCsoActiveLoans",
  async ({ csoId, date, groupLeaderId, groupLeaderName }) => {
    try {
      console.log(date);

      const response = await axios.get(
        `${API_URL}/fetchCsoActiveLoans/${csoId}`,
        {
          params: {
            date,
            groupLeaderId,
            groupLeaderName,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const secondfetchCsoActiveLoans = createAsyncThunk(
  "loan/secondfetchCsoActiveLoans",
  async ({ csoId, date }) => {
    try {
      console.log(date);

      const response = await axios.get(
        `${API_URL}/secondfetchCsoActiveLoans/${csoId}`,
        { params: { date } }, // Pass the date as a query parameter
      );
      return response.data;
    } catch (err) {
      console.error("Error fetching active loans:", err);
      throw err;
    }
  },
);

export const fetchSearchingCsoActiveLoansforCollection = createAsyncThunk(
  "csoLoans/fetchSearchingCsoActiveLoansforCollection",
  async ({ csoId, date, name, groupLeaderId, groupLeaderName }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${API_URL}/fetchSearchingCsoActiveLoansforCollection/${csoId}`,
        {
          params: {
            date,
            name,
            groupLeaderId,
            groupLeaderName,
          },
        },
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchPieRepaymentData = createAsyncThunk(
  "repayment/fetchPieRepaymentData",
  async ({ csoId }) => {
    try {
      const response = await axios.get(
        `${API_URL}/repayment-pie-chart-data/${csoId}`,
      ); // Adjust API endpoint if necessary
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
);

// Async thunk to fetch loan counts
export const fetchLoanAllTimeCounts = createAsyncThunk(
  "loans/fetchLoanAllTimeCounts",
  async ({ csoId }) => {
    try {
      const response = await axios.get(
        `${API_URL}/today-yes-month-loans/${csoId}`,
      );
      return response.data; // returns { todayCount, yesterdayCount, monthCount }
    } catch (error) {
      throw new Error("Error fetching loan counts");
    }
  },
);

// Async thunk to update call status
export const updateCallStatus = createAsyncThunk(
  "loan/updateCallStatus",
  async ({ loanId, field }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/update-call-status`, {
        loanId,
        field,
      });
      return { field, loan: response.data.loan };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const searchCustomer = createAsyncThunk(
  "customer/searchCustomer",
  async (query) => {
    const response = await fetch(`${API_URL}/search?query=${query}`);
    if (!response.ok) {
      throw new Error("Failed to fetch customer");
    }
    const data = await response.json();
    return data;
  },
);

export const searchCustomerCsoHome = createAsyncThunk(
  "customer/searchCustomerCsoHome",
  async ({ query, csoId }) => {
    const response = await fetch(
      `${API_URL}/search-cso-loan?query=${query}&csoId=${csoId}`,
    );
    if (!response.ok) {
      throw new Error("Failed to fetch customer");
    }
    const data = await response.json();
    return data;
  },
);

export const searchActiveCustomer = createAsyncThunk(
  "customer/searchActiveCustomer",
  async (query) => {
    const response = await fetch(
      `${API_URL}/search-customer-active?query=${query}`,
    );
    if (!response.ok) {
      throw new Error("Failed to fetch customer");
    }
    const data = await response.json();
    return data;
  },
);
export const searchPendingCustomer = createAsyncThunk(
  "customer/searchPendingCustomer",
  async (query) => {
    const response = await fetch(
      `${API_URL}/search-pending-loans?query=${query}`,
    );
    if (!response.ok) {
      throw new Error("Failed to fetch customer");
    }
    const data = await response.json();
    return data;
  },
);

export const updateGuarantorFormPic = createAsyncThunk(
  "loan/updateGuarantorFormPic",
  async ({ loanId, imageUrl }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${API_URL}/update-guarantor-form-pic/${loanId}`,
        { imageUrl },
      );
      console.log(response.data.loan);

      return response.data.loan; // Return updated loan data
    } catch (error) {
      return rejectWithValue(error.response.data.message || "Failed to update");
    }
  },
);

// Fetch loans by csoId
export const fetchLoanDashboardLoans = createAsyncThunk(
  "loans/fetchLoanDashboardLoans",
  async (csoId) => {
    const response = await axios.get(
      `${API_URL}/get-loan-dashboard-loans/${csoId}`,
    );
    return response.data;
  },
);

export const deleteLoan = createAsyncThunk(
  "loans/deleteLoan",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/delete-loans/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

// Async thunk to fetch fully paid loans by BVN
export const fetchFullyPaidLoans = createAsyncThunk(
  "loans/fetchFullyPaidLoans",
  async (bvn, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/fully-paid/${bvn}`);
      console.log(response.data);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching fully paid loans",
      );
    }
  },
);

export const fetchDailDisbursedLoans = createAsyncThunk(
  "loans/fetchDailDisbursedLoans",
  async ({ year, month, page }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/get-daily-disbursed`, {
        params: { year, month, page, limit: 20 },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching loans");
    }
  },
);
export const fetchLoanAppForms = createAsyncThunk(
  "loanAppForms/fetchLoanAppForms",
  async ({ csoId, date }, thunkAPI) => {
    try {
      console.log(date);

      const res = await axios.get(
        `${API_URL}/loan-form-app-by-date?csoId=${csoId}&date=${date}`,
      );
      console.log(res.data);

      return res.data;
    } catch (err) {
      console.error("Error fetching active loans:", err);
      throw err;
    }
  },
);

export const fetchLoansByCsoForHome = createAsyncThunk(
  "loans/fetchLoansByCsoForHome",
  async ({ csoId, page, groupLeaderId, groupLeaderName }, thunkAPI) => {
    try {
      const res = await axios.get(`${API_URL}/cso-loans-for-home/${csoId}`, {
        params: {
          page,
          groupLeaderId,
          groupLeaderName,
        },
      });
      return res.data;
    } catch (err) {
      console.error("Error fetching active loans:", err);
      throw err;
    }
  },
);

export const fetchLoanForWeeklyReportCollection = createAsyncThunk(
  "loans/fetchLoanForWeeklyReportCollection",
  async ({ csoId }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${API_URL}/cso-loans-form-download/${csoId}`,
      );
      return res.data;
    } catch (err) {
      console.error("Error fetching active loans:", err);
      throw err;
    }
  },
);

export const fetchDisbursedLoansByDate = createAsyncThunk(
  "disbursedLoans/fetchDisbursedLoansByDate",
  async (date, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}/daily-loan-disbursed-admin?date=${date}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching loans");
    }
  },
);

// Async thunk to update the disbursement picture
export const updateDisbursementPicture = createAsyncThunk(
  "loan/updateDisbursementPicture",
  async ({ id, disbursementPicture }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${API_URL}/user-loan/${id}/disbursement-picture`,
        { disbursementPicture },
      );
      return response.data.loan; // Returning the updated loan
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update disbursement picture",
      );
    }
  },
);

export const fetchDashboardLoanCso = createAsyncThunk(
  "loan/fetchDashboardLoanCso",
  async (csoId, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_URL}/loan-dashboard-cso-loans/${csoId}`,
      );
      return res.data;
      console.log(res.data);
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch loans",
      );
    }
  },
);

// Slice
const loanSlice = createSlice({
  name: "loans",
  initialState: {
    loans: [],
    loanAppForm: [],
    dibursedSuccessMessage: "",
    total: 0,
    page: 1,
    disbursePictureUpload: null,
    disbursePictureloading: false,
    summarypage: 1,
    summarytotalPages: 1,
    summarytotalRecords: 0,
    csoWeeklyReport: null,
    totalPages: 0,
    activeCustomers: [],
    repaymentSchedule: [],
    fullyPaidLoans: [],
    summaries: [],
    details: [],
    disburserloading: false,
    dailyDisburseLoans: [],
    selectedDisburseDate: new Date().toISOString().split("T")[0], // default today
    csoLoanDashdordLoans: [],
    csoDashboardTotalLoans: 0,
    disburseloading: false,
    csoDashboardActiveLoans: 0,
    csoDashboardFullPaidLoans: 0,
    csoDashboardPendingLoans: 0,
    csoDashboardRejectedLoans: 0,
    csoFullyPaidLoansDashbord: null,
    pendingLoans: [],
    rejectedCustomers: [],
    selectedLoan: null,
    currentPage: 1,
    currentWeekStart: new Date(),
    month: new Date().getMonth() + 1, // January is 1, not 0
    year: new Date().getFullYear(),
    totalDisbursed: 0,
    totalToBePaid: 0,
    totalPaid: 0,
    allLoans: [],
    monthlyData: [],
    monthlySummary: [],
    monthlySummaryStatus: false,
    monthlySummaryError: null,
    monthlySummaryYear: new Date().getFullYear(),
    monthlySummaryMatrics: [],
    monthlySummaryMatricsStatus: false,
    monthlySummaryMatricsError: null,
    monthlySummaryMatricsYear: new Date().getFullYear(),
    totalLoans: 0,
    activeLoans: 0,
    pendingLoans: 0,
    rejectedLoans: 0,
    noPaymentYesterday: [],
    defaultingCustomers: [],
    customers: [],
    submitLoanloading: false,
    allDahboardLoans: [],
    activeDashboardLoans: [],
    pendingDashboardLoans: [],
    rejectedDashboardLoans: [],
    paymentSuccess: "",
    paymentError: "",
    paymentRemainingBalance: null,
    wasFinalPayment: false,
    loading: false,
    submitloading: false,
    paymentloading: false,
    error: null,
    filter: "all",
    promptPayments: 0,
    overduePayments: 0,
    secondcustomers: null,
    todayCount: 0,
    yesterdayCount: 0,
    monthCount: 0,
    weekCount: 0,
    fullyPaidLoan: 0,
    csoFullyPaidLoas: null,
    successMessage: "",
    callCso: false,
    apploading: false,
    editLoading: false,
    callGuarantor: false,
    callGroupLeader: false,
    callCustomer: false,
    verifyCustomer: false,
    dailyDisbursedLoans: [],
    dailyDisbursedTotalPages: 1,
    dailyDisbursedCurrentPage: 1,
    csoHomeloans: [],
    udateLoanmessage: null,
    updatedLoan: null,
    allDashBoard: null,
    dashingloading: false,
    collectionloading: false,
    csoHomepage: 1,
    csoHometotalPages: 0,
    pagination: { page: 1, totalPages: 1, limit: 20, total: 0 },
    summaryloading: false,
  },
  reducers: {
    setDisbursedSelectedDate: (state, action) => {
      state.selectedDisburseDate = action.payload;
    },

    clearUpdateLoanMessage: (state) => {
      state.udateLoanmessage = null;
      state.updatedLoan = null;
    },

    setSummaryPage: (state, action) => {
      state.summarypage = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setCsoHomePage: (state, action) => {
      state.csoHomepage = action.payload;
    },
    clearMessages: (state) => {
      state.successMessage = "";
    },
    clearPaymentMessages: (state) => {
      state.paymentSuccess = "";
      state.paymentError = "";
      state.paymentRemainingBalance = null;
      state.wasFinalPayment = false;
    },
    clearDisbursementPicture: (state) => {
      state.disbursePictureUpload = null;
    },
    clearDisbursedMessages: (state) => {
      state.dibursedSuccessMessage = "";
    },
    setPages(state, action) {
      state.currentPage = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setLoans: (state, action) => {
      state.loans = action.payload;
    },
    fetchFullyPaidLoansStart: (state) => {
      state.fullyPaidLoans = []; // Reset state before fetching new data
      state.loading = true;
      state.error = null;
    },
    fetchFullyPaidLoansSuccess: (state, action) => {
      state.fullyPaidLoans = action.payload;
      state.loading = false;
    },
    fetchFullyPaidLoansFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    nextWeek: (state) => {
      state.currentWeekStart = new Date(state.currentWeekStart);
      state.currentWeekStart.setDate(state.currentWeekStart.getDate() + 7);
    },
    previousWeek: (state) => {
      state.currentWeekStart = new Date(state.currentWeekStart);
      state.currentWeekStart.setDate(state.currentWeekStart.getDate() - 7);
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setYear: (state, action) => {
      state.year = action.payload;
    },
    calculateLoanStats: (state) => {
      state.totalLoans = state.loans.length;
      state.activeLoans = state.loans.filter(
        (loan) => loan.status === "active loan",
      ).length;
      state.fullyPaidLoan = state.loans.filter(
        (loan) => loan.status === "fully paid",
      ).length;
      state.csoFullyPaidLoas = state.loans.filter(
        (loan) => loan.status === "fully paid",
      );
      state.pendingLoans = state.loans.filter(
        (loan) =>
          loan.status === "waiting for approval" ||
          loan.status === "waiting for disbursement",
      ).length;
      state.rejectedLoans = state.loans.filter(
        (loan) => loan.status === "rejected",
      ).length;
    },
    calculateLoanStatsCsoLoanDashboard: (state) => {
      state.csoDashboardTotalLoans = state.csoLoanDashdordLoans.length;
      state.csoDashboardActiveLoans = state.csoLoanDashdordLoans.filter(
        (loan) => loan.status === "active loan",
      ).length;
      state.csoDashboardFullPaidLoans = state.csoLoanDashdordLoans.filter(
        (loan) => loan.status === "fully paid",
      ).length;
      state.csoFullyPaidLoansDashbord = state.csoLoanDashdordLoans.filter(
        (loan) => loan.status === "fully paid",
      );
      state.csoDashboardPendingLoans = state.csoLoanDashdordLoans.filter(
        (loan) =>
          loan.status === "waiting for approval" ||
          loan.status === "waiting for disbursement",
      ).length;
      state.csoDashboardRejectedLoans = state.csoLoanDashdordLoans.filter(
        (loan) => loan.status === "rejected",
      ).length;
    },
    calculateDefaultingCustomers: (state) => {
      state.defaultingCustomers = state.loans.filter((loan) => {
        // Check if repaymentSchedule exists and is not empty
        const repaymentSchedule = loan?.repaymentSchedule;
        if (!repaymentSchedule || repaymentSchedule.length === 0) {
          return false; // If no repayment schedule, skip this loan
        }

        // Get the last repayment date (ensure it's in the right format)
        const lastRepaymentDateStr =
          repaymentSchedule[repaymentSchedule.length - 1]?.date;
        console.log("Last Repayment Date:", lastRepaymentDateStr); // Debugging log

        // Convert it to Date if it's a string
        const lastRepaymentDate = new Date(lastRepaymentDateStr);

        if (isNaN(lastRepaymentDate)) {
          console.error("Invalid date format:", lastRepaymentDateStr); // Error logging for invalid date
          return false;
        }

        // Check if the loan is overdue and not fully paid
        const isOverdue = lastRepaymentDate < new Date();
        const isNotFullyPaid =
          loan.loanDetails.amountToBePaid > loan.loanDetails.amountPaidSoFar;

        return isOverdue && isNotFullyPaid;
      });
    },
    calculateNoPaymentYesterday: (state) => {
      state.noPaymentYesterday = state.loans
        .map((loan) => {
          if (!loan.repaymentSchedule || loan.repaymentSchedule.length === 0) {
            return null; // Skip loans without a repayment schedule
          }

          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          const yesterdayDateString = yesterday.toISOString().split("T")[0];

          const repaymentsDueUntilYesterday = loan.repaymentSchedule.filter(
            (repayment) => {
              const repaymentDate = new Date(repayment.date)
                .toISOString()
                .split("T")[0];
              return repaymentDate <= yesterdayDateString;
            },
          );

          const totalDueUntilYesterday = repaymentsDueUntilYesterday.reduce(
            (total, repayment) => total + repayment.amountPaid,
            0,
          );

          const totalPaidUntilYesterday = repaymentsDueUntilYesterday
            .filter((repayment) => repayment.status === "paid")
            .reduce((total, repayment) => total + repayment.amountPaid, 0);

          const amountOwing = totalDueUntilYesterday - totalPaidUntilYesterday;

          if (amountOwing > 0) {
            return {
              customerName: `${loan.customerDetails.firstName} ${loan.customerDetails.lastName}`,
              amountOwingUntilYesterday: amountOwing,
            };
          }
          return null;
        })
        .filter(Boolean); // Remove null values
    },
    setLoan: (state, action) => {
      state.loanUpdate = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Handle loading and data fetching for submitting loan
    builder
      .addCase(submitLoanApplication.pending, (state) => {
        state.submitLoanloading = true;
      })
      .addCase(submitLoanApplication.fulfilled, (state, action) => {
        state.submitLoanloading = false;
        state.loans.push(action.payload); // Add the new loan to the loans array
        state.successMessage = action.payload.message;
      })
      .addCase(submitLoanApplication.rejected, (state, action) => {
        state.submitLoanloading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateLoan.pending, (state) => {
        state.updatingLoanLoading = true;
        state.error = null;
      })
      .addCase(updateLoan.fulfilled, (state, action) => {
        state.updatingLoanLoading = false;
        state.udateLoanmessage = action.payload.message;

        // Update loan in state
        const updatedLoan = action.payload.loan;
        const index = state.loans.findIndex(
          (loan) => loan._id === updatedLoan._id,
        );
        if (index !== -1) {
          state.loans[index] = updatedLoan;
        } else {
          state.loans.push(updatedLoan);
        }
      })
      .addCase(updateLoan.rejected, (state, action) => {
        state.updatingLoanLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchLoanMonthlySummary.pending, (state) => {
        state.monthlySummaryStatus = true;
        state.monthlySummaryError = null;
      })
      .addCase(fetchLoanMonthlySummary.fulfilled, (state, action) => {
        state.monthlySummaryStatus = false;
        state.monthlySummary = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
        state.monthlySummaryYear =
          action.payload?.year ?? action.meta?.arg ?? new Date().getFullYear();
      })
      .addCase(fetchLoanMonthlySummary.rejected, (state, action) => {
        state.monthlySummaryStatus = false;
        state.monthlySummaryError = action.payload || action.error.message;
        state.monthlySummary = [];
      })

      .addCase(fetchLoanMonthlyMatrics.pending, (state) => {
        state.monthlySummaryMatricsStatus = true;
        state.monthlySummaryMatricsError = null;
      })
      .addCase(fetchLoanMonthlyMatrics.fulfilled, (state, action) => {
        state.monthlySummaryMatricsStatus = false;
        state.monthlySummaryMatrics = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
        state.monthlySummaryMatricsYear =
          action.payload?.year ?? action.meta?.arg ?? new Date().getFullYear();
      })
      .addCase(fetchLoanMonthlyMatrics.rejected, (state, action) => {
        state.monthlySummaryMatricsStatus = false;
        state.monthlySummaryMatricsError =
          action.payload || action.error.message;
        state.monthlySummaryMatrics = [];
      })

      .addCase(updateDisbursementPicture.pending, (state) => {
        state.disbursePictureloading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateDisbursementPicture.fulfilled, (state, action) => {
        state.disbursePictureloading = false;
        state.success = true;
        state.disbursePictureUpload = action.payload;
      })
      .addCase(updateDisbursementPicture.rejected, (state, action) => {
        state.disbursePictureloading = false;
        state.success = false;
        state.error = action.payload;
      });

    builder

      .addCase(fetchDashboardLoanCso.pending, (state) => {
        state.dashingloading = true;
        state.error = null;
      })
      .addCase(fetchDashboardLoanCso.fulfilled, (state, action) => {
        state.dashingloading = false;
        state.error = null;

        state.allDashBoard = action.payload;
      })
      .addCase(fetchDashboardLoanCso.rejected, (state, action) => {
        state.dashingloading = false;
        state.error = action.payload;
      });

    builder
      // Edit Loan Status
      .addCase(editLoanStatus.pending, (state) => {
        state.editLoading = true;
        state.error = null;
      })
      .addCase(editLoanStatus.fulfilled, (state, action) => {
        state.editLoading = false;
        state.updatedLoan = action.payload;
        const updatedLoan = action.payload;

        // update the loan in the loans array
        state.loans = state.loans.map((loan) =>
          loan._id === updatedLoan._id ? updatedLoan : loan,
        );
      })
      .addCase(editLoanStatus.rejected, (state, action) => {
        state.editLoading = false;
        state.error = action.payload?.message || "Failed to edit loan";
      });

    builder
      .addCase(fetchDisbursedLoansByDate.pending, (state) => {
        state.disburserloading = true;
        state.error = null;
      })
      .addCase(fetchDisbursedLoansByDate.fulfilled, (state, action) => {
        state.disburserloading = false;
        state.dailyDisburseLoans = action.payload;
      })
      .addCase(fetchDisbursedLoansByDate.rejected, (state, action) => {
        state.disburserloading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchLoansByCsoForHome.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoansByCsoForHome.fulfilled, (state, action) => {
        state.loading = false;
        state.csoHomeloans = action.payload.loans;
        state.csoHometotalPages = action.payload.totalPages;
      })
      .addCase(fetchLoansByCsoForHome.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchLoanForWeeklyReportCollection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchLoanForWeeklyReportCollection.fulfilled,
        (state, action) => {
          state.loading = false;
          state.csoWeeklyReport = action.payload;
          state.csoHometotalPages = action.payload.totalPages;
        },
      )
      .addCase(fetchLoanForWeeklyReportCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAllLoansByCsoIdLoanDashboardLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAllLoansByCsoIdLoanDashboardLoans.fulfilled,
        (state, action) => {
          state.loading = false;
          state.csoLoanDashdordLoans = action.payload;
          loanSlice.caseReducers.calculateLoanStatsCsoLoanDashboard(state);
        },
      )
      .addCase(
        fetchAllLoansByCsoIdLoanDashboardLoans.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload || "Failed to fetch loans";
        },
      );

    builder
      .addCase(fetchLoanAppForms.pending, (state) => {
        state.apploading = true;
      })
      .addCase(fetchLoanAppForms.fulfilled, (state, action) => {
        state.loanAppForm = action.payload;
        state.apploading = false;
      })
      .addCase(fetchLoanAppForms.rejected, (state, action) => {
        state.error = action.error.message;
        state.apploading = false;
      });

    builder
      .addCase(fetchDailDisbursedLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailDisbursedLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.dailyDisbursedLoans = action.payload.loans;
        state.dailyDisbursedTotalPages = action.payload.totalPages;
        state.dailyDisbursedCurrentPage = action.payload.currentPage;
      })
      .addCase(fetchDailDisbursedLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchFullyPaidLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFullyPaidLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.fullyPaidLoans = action.payload;
      })
      .addCase(fetchFullyPaidLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(searchCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload;
      })
      .addCase(searchCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(searchCustomerCsoHome.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchCustomerCsoHome.fulfilled, (state, action) => {
        state.loading = false;
        state.csoHomeloans = action.payload;
      })
      .addCase(searchCustomerCsoHome.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteLoan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = state.loans.filter(
          (loan) => loan._id !== action.payload.loan._id,
        );
      })
      .addCase(deleteLoan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchAdminLoans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdminLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload;
      })
      .addCase(fetchAdminLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAdminLoansNewOne.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminLoansNewOne.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchAdminLoansNewOne.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";
      });

    builder
      .addCase(fetchAdminLoansSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminLoansSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload;
      })
      .addCase(fetchAdminLoansSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchLoanDashboardLoans.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLoanDashboardLoans.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allDahboardLoans = action.payload.allLoans;
        state.activeDashboardLoans = action.payload.activeLoans;
        state.pendingDashboardLoans = action.payload.pendingLoans;
        state.rejectedDashboardLoans = action.payload.rejectedLoans;
      })
      .addCase(fetchLoanDashboardLoans.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(searchActiveCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchActiveCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.summaries = action.payload;
      })
      .addCase(searchActiveCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(searchPendingCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchPendingCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingLoans = action.payload;
      })
      .addCase(searchPendingCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateGuarantorFormPic.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGuarantorFormPic.fulfilled, (state, action) => {
        state.loading = false;
        // Update the specific loan in the state
        const index = state.loans.findIndex(
          (loan) => loan._id === action.payload._id,
        );
        if (index !== -1) {
          state.loans[index] = action.payload;
        }
      })
      .addCase(updateGuarantorFormPic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateCallStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCallStatus.fulfilled, (state, action) => {
        state.loading = false;
        state[action.payload.field] = true;
      })
      .addCase(updateCallStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });

    builder
      .addCase(fetchLoanAllTimeCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoanAllTimeCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.todayCount = action.payload.todayCount;
        state.yesterdayCount = action.payload.yesterdayCount;
        state.monthCount = action.payload.monthCount;
        state.weekCount = action.payload.weekCount;
      })
      .addCase(fetchLoanAllTimeCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchCsoActiveLoans.pending, (state) => {
        state.collectionloading = true;
        state.error = null;
      })
      .addCase(fetchCsoActiveLoans.fulfilled, (state, action) => {
        state.collectionloading = false;
        state.customers = action.payload;
      })
      .addCase(fetchCsoActiveLoans.rejected, (state, action) => {
        state.collectionloading = false;
        state.error = action.payload;
      });

    builder
      .addCase(secondfetchCsoActiveLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(secondfetchCsoActiveLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.secondcustomers = action.payload;
      })
      .addCase(secondfetchCsoActiveLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchSearchingCsoActiveLoansforCollection.pending, (state) => {
        state.searchloading = true;
        state.error = null;
      })
      .addCase(
        fetchSearchingCsoActiveLoansforCollection.fulfilled,
        (state, action) => {
          state.searchloading = false;
          state.customers = action.payload;
        },
      )
      .addCase(
        fetchSearchingCsoActiveLoansforCollection.rejected,
        (state, action) => {
          state.searchloading = false;
          state.error = action.payload || "Something went wrong";
        },
      );

    builder
      .addCase(fetchPieRepaymentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPieRepaymentData.fulfilled, (state, action) => {
        state.promptPayments = action.payload.promptPayments;
        state.overduePayments = action.payload.overduePayments;
        state.loading = false;
      })
      .addCase(fetchPieRepaymentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAllLoansByCsoId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllLoansByCsoId.fulfilled, (state, action) => {
        state.loans = action.payload.loans;
        state.total = action.payload.total;
        loanSlice.caseReducers.calculateLoanStats(state);
        state.loading = false;
      })
      .addCase(fetchAllLoansByCsoId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchCustomersSummary.pending, (state) => {
        state.summaryloading = true;
      })
      .addCase(fetchCustomersSummary.fulfilled, (state, action) => {
        state.summaries = action.payload.data;
        state.summarytotalPages = action.payload.totalPages;
        state.summarytotalRecords = action.payload.totalRecords;
        state.summaryloading = false;
      })
      .addCase(fetchCustomersSummary.rejected, (state) => {
        state.summaryloading = false;
      });

    builder

      .addCase(fetchCustomerDetails.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchCustomerDetails.fulfilled, (state, action) => {
        state.details = action.payload;
      })

      .addCase(fetchCustomerDetails.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchLoans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload.loans;
        state.total = action.payload.total;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchPendingLoans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPendingLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingLoans = action.payload;
      })
      .addCase(fetchPendingLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder

      .addCase(fetchWaitingLoans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWaitingLoans.fulfilled, (state, action) => {
        state.loans = action.payload.loans;
        state.totalLoans = action.payload.totalLoans;
        state.totalPages = action.payload.totalPages;
        state.loading = false;
      })
      .addCase(fetchWaitingLoans.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(makePaymenting.pending, (state) => {
        state.paymentloading = true;
        state.paymentError = null;
      })
      .addCase(makePaymenting.fulfilled, (state, action) => {
        state.paymentloading = false;
        state.selectedLoan = action.payload?.loan || action.payload;
        state.paymentSuccess = action.payload?.message || "";
        state.paymentRemainingBalance =
          action.payload?.remainingBalance ?? null;
        state.wasFinalPayment = !!action.payload?.wasFinalPayment;
      })
      .addCase(makePaymenting.rejected, (state, action) => {
        state.paymentloading = false;
        const errorPayload = action.payload;
        state.paymentError =
          errorPayload?.error ||
          errorPayload?.message ||
          action.error?.message ||
          "Payment failed";
        state.paymentSuccess = "";
        state.paymentRemainingBalance = null;
        state.wasFinalPayment = false;
      });

    builder
      .addCase(disburseLoan.pending, (state) => {
        state.disburseloading = true;
        state.error = null;
      })
      .addCase(disburseLoan.fulfilled, (state, action) => {
        state.disburseloading = false;

        // Remove the disbursed loan from the list
        state.loans = state.loans.filter(
          (loan) => loan._id !== action.payload.loan._id,
        );

        // Optional: show success message
        state.dibursedSuccessMessage = action.payload.message;
      })
      .addCase(disburseLoan.rejected, (state, action) => {
        state.disburseloading = false;
        state.error = action.error.message || "Failed to disburse loan";
      });

    builder
      .addCase(fetchWaitingDisbursementLoans.fulfilled, (state, action) => {
        state.loans = action.payload;
      })
      // .addCase(disburseLoan.fulfilled, (state, action) => {
      //   state.loans = state.loans.filter(
      //     (loan) => loan._id !== action.payload.loan._id
      //   );
      // })
      .addCase(fetchActiveCustomers.fulfilled, (state, action) => {
        state.activeCustomers = action.payload;
      })

      .addCase(fetchRepaymentSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRepaymentSchedule.fulfilled, (state, action) => {
        state.repaymentSchedule = action.payload.repaymentSchedule || [];
        state.loading = false;
      })

      .addCase(fetchLoanById.fulfilled, (state, action) => {
        state.selectedLoan = action.payload;
      })
      .addCase(fetchLoanByBvn.fulfilled, (state, action) => {
        state.selectedLoan = action.payload;
      })

      .addCase(approveLoan.fulfilled, (state, action) => {
        const index = state.loans.findIndex(
          (loan) => loan._id === action.payload._id,
        );
        if (index !== -1) {
          state.loans[index] = action.payload;
        }
      })
      .addCase(rejectLoan.fulfilled, (state, action) => {
        const index = state.loans.findIndex(
          (loan) => loan._id === action.payload._id,
        );
        if (index !== -1) {
          state.loans[index] = action.payload;
        }
      });
    builder
      .addCase(fetchRejectedCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRejectedCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.rejectedCustomers = action.payload;
      })
      .addCase(fetchRejectedCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchCustomerActiveLoans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerActiveLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload?.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchCustomerActiveLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchCustomerActiveLoansSearch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerActiveLoansSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload;
      })
      .addCase(fetchCustomerActiveLoansSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchLoansByMonth.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoansByMonth.fulfilled, (state, action) => {
        state.loans = action.payload;
        state.loading = false;
      })
      .addCase(fetchLoansByMonth.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(allLaonfTransactions.fulfilled, (state, action) => {
        state.allLoans = action.payload;
      });
    builder
      .addCase(fetchDisbursementDataChart.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDisbursementDataChart.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyData = action.payload;
      })
      .addCase(fetchDisbursementDataChart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const {
  setSummaryPage,
  setPage,
  setPages,
  setLoans,
  clearMessages,
  setFilter,
  nextWeek,
  previousWeek,
  setMonth,
  setYear,
  setDisbursedSelectedDate,
  clearDisbursedMessages,
  clearPaymentMessages,
  calculateLoanStats,
  calculateLoanStatsCsoLoanDashboard,
  calculateDefaultingCustomers,
  calculateNoPaymentYesterday,
  fetchFullyPaidLoansStart,
  clearDisbursementPicture,
  fetchFullyPaidLoansSuccess,
  fetchFullyPaidLoansFailure,
  setCsoHomePage,
  clearUpdateLoanMessage,
  setLoan,
} = loanSlice.actions;
export default loanSlice.reducer;
